"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _browserHelpers = require("@flowio/browser-helpers");

var _utilities = require("./utilities");

// @ts-check

/** @typedef {import('./types').DropdownOptions} DropdownOptions */

/** @typedef {import('./types').DropdownOptionConfig} DropdownOptionConfig */
var Dropdown = function Dropdown() {
  (0, _classCallCheck2["default"])(this, Dropdown);
};

exports["default"] = Dropdown;
(0, _defineProperty2["default"])(Dropdown, "svgCheck", "<svg class=\"svg-check\" style=\"align-self:center\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n      <defs>\n        <path d=\"M8.9 21.583a1.78 1.78 0 0 1-1.259-.52l-7.12-7.12a1.78 1.78 0 1 1 2.518-2.518l5.757 5.757 12.07-14.157a1.781 1.781 0 0 1 2.709 2.31l-13.32 15.623a1.78 1.78 0 0 1-1.355.625z\" id=\"a\"/>\n      </defs>\n      <use fill=\"#0051b2\" xlink:href=\"#a\" fill-rule=\"evenodd\"/>\n    </svg>");
(0, _defineProperty2["default"])(Dropdown, "generateDropdownOptions", function (opts) {
  var generatedOptions = [];
  var instructionItem = (0, _utilities.createDomElement)('div', {
    "class": 'flow-country-picker-instruction-txt'
  });
  instructionItem.innerHTML = opts.title;
  generatedOptions.push(instructionItem);
  Object.keys(opts.options).forEach(function (optionKey) {
    var menuItem = (0, _utilities.createDomElement)('a', {
      'data-value': optionKey,
      'class': 'flow-country-picker-dropdown-item'
    });
    /** @type {DropdownOptionConfig} */

    var currentItem = opts.options[optionKey];
    var label = currentItem.label,
        imgSrc = currentItem.imgSrc,
        name = currentItem.name,
        iso_3166_2 = currentItem.iso_3166_2;
    var isSelected = optionKey === opts.selectedKey;

    if (isSelected && typeof opts.selectedClass === 'string') {
      (0, _browserHelpers.addClass)(menuItem, opts.selectedClass);
    }

    var menuInnerHTML = [];
    var countryLogo = (0, _utilities.getCountryFlagImageHTML)(iso_3166_2, opts.logo, name || label, {
      imgSrc: imgSrc
    });

    if (countryLogo) {
      menuInnerHTML.push('<div class="flow-country-picker-country-logo">', countryLogo, '</span></div>');
    }

    menuInnerHTML.push("<div class=\"flow-country-picker-dropdown-option-text\">".concat(label, "</div>"));
    if (isSelected) menuInnerHTML.push(Dropdown.svgCheck);
    menuItem.innerHTML = menuInnerHTML.join('');
    (0, _browserHelpers.addEvent)(menuItem, 'click', function (event) {
      var currentTarget = event.currentTarget; // @ts-ignore

      var value = currentTarget.getAttribute('data-value');
      opts.onItemSelect({
        value: value,
        item: currentItem,
        event: event
      });
    });
    generatedOptions.push(menuItem);
  });
  return generatedOptions;
});


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/country-picker/lib/dropdown_component.js
// module id = 303
// module chunks = 0 1